import { Pill, PillVariants } from "src/base-components/Pill";
import { TruncatedIdPill } from "src/base-components/TruncatedIdPill";
import { CaseStatusPill } from "src/cases/common/CaseStatusPill";
import { CaseDeserialized } from "src/cases/queries/casesTypes";
import {
  getPriorityDisplay,
  getStatusDisplay,
  getSubStatusDisplayName,
} from "src/cases/utils";
import { Skeleton } from "src/design-system/Skeleton";

interface CasePageHeaderTitleProps {
  caseData: CaseDeserialized | undefined;
  isLoading: boolean;
  contextLabel: string;
}

export const CasePageHeaderTitle: React.FC<CasePageHeaderTitleProps> = ({
  caseData,
  isLoading,
  contextLabel,
}) => {
  const { case_properties: caseProperties, template_version: templateVersion } =
    caseData?.data || {};

  const statusStr = String(caseProperties?.status || "");
  const statusDisplay = caseProperties
    ? getStatusDisplay(statusStr, templateVersion)
    : undefined;
  const priorityDisplay = caseProperties?.priority
    ? getPriorityDisplay(String(caseProperties.priority), templateVersion)
    : undefined;

  return (
    <div className="flex items-center gap-x-1.5">
      {contextLabel}
      <div className="flex items-center gap-x-1.5">
        {isLoading ? (
          <Skeleton height="h-6" width="w-60" />
        ) : (
          caseData && <CaseId value={caseData.data.id} />
        )}
        {isLoading ? (
          <Skeleton height="h-6" width="w-20" />
        ) : (
          caseProperties &&
          statusDisplay && (
            <CaseStatusPill
              dataLoc="case-view-status-pill"
              status={statusDisplay.displayName}
              subStatus={
                caseProperties.sub_status
                  ? getSubStatusDisplayName(
                      statusStr,
                      String(caseProperties.sub_status),
                      templateVersion,
                    )
                  : undefined
              }
              variant={statusDisplay.variant}
            />
          )
        )}
        {priorityDisplay ? (
          <Pill
            dataLoc="case-view-priority-pill"
            size="sm"
            variant={priorityDisplay.variant as PillVariants}
          >
            <Pill.Text>{priorityDisplay.displayName}</Pill.Text>
          </Pill>
        ) : null}
      </div>
    </div>
  );
};

const CaseId: React.FC<{ value: string }> = ({ value }) => (
  <div className="max-w-24">
    <TruncatedIdPill feedback="inline-only-checkmark" id={value} />
  </div>
);
